import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TherapyRoomModel } from '../../models/TherapyRoomModel'


export interface TherapyRoomState {
    TherapyRoom: TherapyRoomModel
    TherapyRoomList: TherapyRoomModel[]
}

const initialState: TherapyRoomState = {
    TherapyRoom: {} as TherapyRoomModel,
    TherapyRoomList: [],
}

export const TherapyRoomSlice = createSlice({
    name: 'therapyroom',
    initialState,
    reducers: {
        setTherapyRoom: (state, action: PayloadAction<TherapyRoomModel[]>) => {
            state.TherapyRoomList = action.payload
        },
        saveTherapyRoom: (state, action: PayloadAction<TherapyRoomModel>) => {
            let room = action.payload
            if (room.Id > 0) {
                let defaultModel: TherapyRoomModel = { Id: 0, TherapyRoomName: room.TherapyRoomName }
                let currentRoom =
                    state.TherapyRoomList.find((c) => c.Id === room.Id) || defaultModel
                    currentRoom.TherapyRoomName = room.TherapyRoomName
            } else {
                room.Id = (Math.max(...state.TherapyRoomList.map((c) => c.Id)) || 0) + 1
                state.TherapyRoomList.push(room)
            }
        },
        getTherapyRoomById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let therapyroom: TherapyRoomModel = {} as TherapyRoomModel
            if (id > 0) {
                let currentTherapyRoom: TherapyRoomModel[] = state.TherapyRoomList
                therapyroom = currentTherapyRoom.find((c) => c.Id === id) || ({} as TherapyRoomModel)
            }

            state.TherapyRoom = therapyroom
        },
        deleteTherapyRoom: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentTherapyRoom: TherapyRoomModel[] = state.TherapyRoomList
                state.TherapyRoomList = currentTherapyRoom.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setTherapyRoom, saveTherapyRoom, getTherapyRoomById, deleteTherapyRoom } =
TherapyRoomSlice.actions

export default TherapyRoomSlice.reducer
